import React from 'react';

import { getHomePageId } from '@lumapps/instance/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';

import { ContentLink, ContentLinkProps } from '../ContentLink';

export type HomeLinkProps = Omit<ContentLinkProps, 'to'>;

/** Link to home page (content page link) */
export const HomeLink = React.forwardRef<HTMLAnchorElement, HomeLinkProps>(({ children, ...forwardedProps }, ref) => {
    const homePageId = useSelector(getHomePageId);
    return (
        <ContentLink {...forwardedProps} ref={ref} to={{ id: homePageId, isHomePage: true }}>
            {children}
        </ContentLink>
    );
});
